export default __webpack_public_path__ + "static/media/IMG_0043_8_11zon.fc04efe3.jpg";